import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { Subscription } from 'rxjs';
import ICalendar from '../../../_interfaces/ICalendar';
import { CalendarService } from '../../../_services/calendars/calendar.service';
import { SessionService } from '../../../_services/session/session.service';
import { BaseComponent } from '../../base/base.component';

@Component({
  standalone: true,
  selector: 'app-selector-calendar',
  templateUrl: './selector-calendar.component.html',
  styleUrls: ['./selector-calendar.component.scss'],
  imports: [SelectModule, FormsModule],
})
export class SelectorCalendarComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @Input() onSelect: (calendar: ICalendar) => void; // Callback para enviar el calendario seleccionado
  @Input('default') selectedCalendar: { code: number; name: string }; // Calendario predeterminado

  calendars: ICalendar[] = []; // Lista de calendarios
  options: { code: number; name: string }[] = []; // Opciones para el dropdown
  private subscriptionActiveSite: Subscription;

  constructor(
    public session: SessionService,
    public calendarsService: CalendarService
  ) {
    super(session);
  }

  /**
   * Encuentra el calendario seleccionado en la lista actual de calendarios.
   */
  private getSelectedCalendar(): ICalendar | undefined {
    return this.calendars.find(
      (calendar) => calendar.id === this.selectedCalendar?.code
    );
  }

  /**
   * Sincroniza el calendario seleccionado y notifica el cambio.
   */
  private updateSelectedCalendar(): void {
    const selectedOption = this.options.find(
      (o) => o.code === this.selectedCalendar?.code
    );
    this.selectedCalendar = selectedOption || this.options[0] || null;
    this.notifySelection();
  }

  /**
   * Llama al callback `onSelect` con el calendario seleccionado.
   */
  public notifySelection(): void {
    const calendar = this.getSelectedCalendar();
    if (calendar) {
      this.onSelect(calendar);
    }
  }

  private resetCalendars(): void {
    this.calendars = [];
    this.options = [];
    this.selectedCalendar = null;
  }

  private hasCalendarContext(): boolean {
    return Number(this.customers_id || 0) > 0 && Number(this.site?.id || 0) > 0;
  }

  /**
   * Carga los calendarios desde el servicio y actualiza las opciones.
   */
  public loadCalendars(): void {
    if (!this.hasCalendarContext()) {
      this.resetCalendars();
      return;
    }

    this.calendarsService.get(this.customers_id, this.site).subscribe({
      next: (calendars: ICalendar[]) => {
        this.calendars = calendars || [];
        this.options = this.calendars.map((calendar) => ({
          code: calendar.id,
          name: calendar.name,
        }));
        this.updateSelectedCalendar(); // Actualiza la selección después de cargar los calendarios
      },
      error: () => {
        this.resetCalendars();
      },
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadCalendars();

    this.subscriptionActiveSite = this.session.getSite$().subscribe((site) => {
      if (Number(site?.id || 0) > 0) {
        this.loadCalendars();
      } else {
        this.resetCalendars();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptionActiveSite?.unsubscribe();
    super.ngOnDestroy();
  }
}
